import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

import LoginScreen from 'components/Page/auth/LoginScreen'
import ForgotPasswordScreen from 'components/Page/auth/ForgotPasswordScreen'
import PasswordResetScreen from 'components/Page/auth/PasswordResetScreen'
import PasswordResetSuccessScreen from 'components/Page/auth/PasswordResetSuccessScreen'
import PasswordUpdateScreen from 'components/Page/auth/PasswordUpdateScreen'
import { logIn, updatePassword, forgotPassword, resetPassword } from 'http/auth'
import { setLoader } from 'utils/loader'

enum Screen {
  LOGIN,
  FORGOT_PASSWORD,
  PASSWORD_RESET,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_UPDATE,
}

interface IProps { }

interface IState {
  screen: Screen
  cognitoUser: any
  username: string
  error: string
}

class Login extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      screen: Screen.LOGIN,
      username: '',
      cognitoUser: null,
      error: '',
    }
  }

  _handleLogin = async (username, password) => {
    setLoader(true)

    try {
      const user = await logIn(username, password)
      localStorage.setItem('username', username);
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.setState(state => ({
          ...state,
          cognitoUser: user,
          screen: Screen.PASSWORD_UPDATE,
        }))
      }
    } catch (error) {
      console.log(error)
      let errorMsg = ''
      if (error.code === 'PasswordResetRequiredException') {
        this.setState(state => ({
          ...state,
          username,
          screen: Screen.PASSWORD_RESET,
        }))
      } else if (error.code === 'UserNotFoundException') {
        errorMsg = 'User does not exist!'
      } else if (error.code === 'NotAuthorizedException') {
        errorMsg = 'Password is incorrect!'
      } else {
        errorMsg = `Unhandled error ${error.code}`
      }

      this.setState(state => ({
        ...state,
        error: errorMsg,
      }))
    }
    setLoader(false)
  }

  _handlePasswordUpdate = async (password: string) => {
    const { cognitoUser } = this.state

    if (!cognitoUser) {
      console.log('should never reach here')
      return
    }
    setLoader(true)
    try {
      await updatePassword(cognitoUser, password)
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }

  _handleForgotPassword = async (username: string) => {
    setLoader(true)
    try {
      await forgotPassword(username)
    } catch (error) { }
    this.setState({
      ...this.state,
      username,
      screen: Screen.PASSWORD_RESET,
    })
    setLoader(false)
  }

  _handlePasswordReset = async (code: string, password: string) => {
    const { username } = this.state

    if (!username) {
      // should never reach here
      return
    }
    setLoader(true)
    try {
      await resetPassword(username, code, password)
      this._switchScreen(Screen.PASSWORD_RESET_SUCCESS)
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }

  _switchScreen = (screen: Screen) =>
    this.setState(state => ({
      ...state,
      screen,
    }))

  render() {
    const { screen, error } = this.state
    return (
      <Grid container justify="center" alignItems="center">
        <Grid container direction="column" item xs={10} md={8} lg={4}>
          <Grid container item justify="center">
            <Box mb={5} width="50%">
              <img style={{ width: '100%' }} src="/images/logos/boc.svg" />
            </Box>
          </Grid>
          {screen === Screen.LOGIN && (
            <LoginScreen
              error={error}
              handleLogin={this._handleLogin}
              forgotPassword={() => this._switchScreen(Screen.FORGOT_PASSWORD)}
            />
          )}
          {screen === Screen.PASSWORD_UPDATE && (
            <PasswordUpdateScreen error={error} handlePasswordUpdate={this._handlePasswordUpdate} />
          )}
          {screen === Screen.FORGOT_PASSWORD && (
            <ForgotPasswordScreen
              error={error}
              handleForgotPassword={this._handleForgotPassword}
              login={() => this._switchScreen(Screen.LOGIN)}
            />
          )}
          {screen === Screen.PASSWORD_RESET && (
            <PasswordResetScreen
              error={error}
              handlePasswordReset={this._handlePasswordReset}
              goBack={() => this._switchScreen(Screen.FORGOT_PASSWORD)}
            />
          )}
          {screen === Screen.PASSWORD_RESET_SUCCESS && (
            <PasswordResetSuccessScreen login={() => this._switchScreen(Screen.LOGIN)} />
          )}
        </Grid>
      </Grid>
    )
  }
}

export default Login
